import { Directive } from '@angular/core';
import {
  Validator,
  NG_VALIDATORS,
  ValidatorFn,
  FormControl,
  AbstractControl
} from '@angular/forms';

@Directive({
  selector: '[dateValidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useClass: DateValidatorDirective,
      multi: true
    }
  ]
})
export class DateValidatorDirective implements Validator {
  validator: ValidatorFn;
  constructor() {
    this.validator = this.dateValidator();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      return !isNaN(Date.parse(control.value)) ? null : { invalidDate: true };
    };
  }
}
